// extracted by mini-css-extract-plugin
module.exports =  {"columns":"wB6eZeGzn4oKJ2kk54Cr","content":"VRKH9dU9NcNyhrpB_e1K"};